import { mobiIng } from '@/shared/fai';
import {
    otherAdd,
    sendMobileLoginCode,
    loginMember,
    checkMobileCodeGeneral,
    loginMemberByMobile,
    otherLoginMember,
    checkHaveMultipleMemberAjax,
    loginLog,
    bindOtherAcctFirstAjax,
    getMobileCode,
} from '@/api/member';
import { logMallFdp, logDog, logErr } from '@/shared/log';
import {
    memberActive,
    mallBuyLoginCheck,
    otherLoginErrno,
    selectValueChange,
    getSignMobileCodeCountDown,
} from '../method';
import { preprocessUrl } from '@/shared/url';
import { showMemberLoginMsg } from '@/shared/member';

import { isNull } from '../util';
import { changeHref } from '@/features/router/universal';
import { clueReuqestVm } from '@jz/biz-shared';

import { prompt } from '@/shared/fai';
import { decodeHtml } from '@/shared/util';
const memberOtherLoginSubmit = function (
    name,
    loginType,
    openId,
    url,
    avator,
    faiOpenId
) {
    var info = {};
    info['mobileSign'] = Fai.top.tmpMobileCodeSgin;
    info['headImgUrl'] = avator;
    info['name'] = name;
    var fillContent = {};
    var userAddItemName = '';
    var userAddItemValue = '';
    var isUserAddItemNameTooLong = 0;
    var userAddItemMaxLength = '';
    var isUserAddItemPass = 0;
    jm('#fillAcctInfo .userAddItem').each(function () {
        let userAddItemID = jm(this).attr('id');
        userAddItemValue = jm(this).val();
        userAddItemName = jm(this).attr('name');
        userAddItemMaxLength = jm(this).attr('maxlength');
        info[userAddItemID] = userAddItemValue;
        fillContent[userAddItemName] = userAddItemValue;
        if (
            typeof userAddItemMaxLength != 'undefined' &&
            userAddItemMaxLength != null &&
            userAddItemValue.length > userAddItemMaxLength
        ) {
            mobiIng(
                jm.format(
                    LS.memberSignupUserAddItemMaxLength,
                    userAddItemName,
                    userAddItemMaxLength
                )
            );
            document.getElementById(userAddItemID).focus();
            isUserAddItemNameTooLong = 1;
            return false;
        }
        if (userAddItemID == 'email' && userAddItemValue.length > 0) {
            if (!jm.isEmail(userAddItemValue)) {
                mobiIng(
                    jm.format(
                        LS.memberSignupUserAddItemCorrect,
                        userAddItemName
                    )
                );
                document.getElementById(userAddItemID).focus();
                isUserAddItemPass = 1;
                return false;
            }
        }
        if (userAddItemID == 'mobile' && userAddItemValue.length > 0) {
            if (!jm.isNationMobile(userAddItemValue)) {
                mobiIng(LS.mobileNumRegular);
                document.getElementById(userAddItemID).focus();
                isUserAddItemPass = 1;
                return false;
            } else {
                info['mobileCt'] = jm('#mobileCt').val();
            }
        }
    });

    let dataOption = {};

    if (isUserAddItemPass == 1) {
        return;
    }
    if (isUserAddItemNameTooLong == 1) {
        return;
    }

    // 判断验证码和手机验证码
    if (
        typeof jm('#messageAuthCode').attr('maxlength') != 'undefined' &&
        jm('#messageAuthCode').attr('maxlength') != null
    ) {
        var memberSignupCaptcha = jm('#memberSignupCaptcha').val();
        if (
            typeof memberSignupCaptcha == 'undefined' ||
            memberSignupCaptcha == null ||
            memberSignupCaptcha == ''
        ) {
            mobiIng(LS.memberInputCaptcha);
            return false;
        }

        var messageAuthCode = jm('#messageAuthCode').val();
        if (
            typeof messageAuthCode == 'undefined' ||
            messageAuthCode == null ||
            messageAuthCode == ''
        ) {
            mobiIng(LS.inputMobileCode);
            return false;
        }
        info['messageAuthCode'] = messageAuthCode;
    }

    var isCheckUAIStatus = 0;
    jm('.isCheckUAI').each(function () {
        let userAddItemID = jm(this).attr('id');
        userAddItemValue = jm(this).val();
        userAddItemName = jm(this).attr('name');
        if (userAddItemValue == null || userAddItemValue == '') {
            if (jm(this).is('input')) {
                mobiIng(
                    jm.format(
                        LS.memberSignupUserAddItemIsEmpty,
                        userAddItemName
                    )
                );
            } else {
                mobiIng(
                    jm.format(
                        LS.memberSignupUserAddItemIsEmpty2,
                        userAddItemName
                    )
                );
            }
            document.getElementById(userAddItemID).focus();
            isCheckUAIStatus = 1;
            return false;
        }

        if (userAddItemID == 'email' && userAddItemValue.length > 0) {
            if (!jm.isEmail(userAddItemValue)) {
                mobiIng(
                    jm.format(
                        LS.memberSignupUserAddItemCorrect,
                        userAddItemName
                    )
                );
                document.getElementById(userAddItemID).focus();
                isCheckUAIStatus = 1;
                return false;
            }
        }
    });
    if (isCheckUAIStatus == 1) {
        return;
    }

    var unionId = '';
    if (typeof Mobi.w_unionId != 'undefined' && Mobi.w_unionId) {
        unionId = Mobi.w_unionId;
    }

    dataOption['info'] = jm.toJSON(info);
    Object.assign(dataOption, {
        loginType,
        faiOpenId,
        openId,
        unionId,
    });

    otherAdd(dataOption)
        .catch(() => {
            mobiIng(LS.memberSignupRegisterError);
        })
        .then((data) => {
            let loginMethod = '';
            if (loginType == 1) {
                loginMethod = 'qq登录';
            } else if (loginType == 2) {
                loginMethod = '微博登录';
            } else if (loginType == 3 || loginType == 4 || loginType == 5) {
                loginMethod = '微信登录';
            }
            /*mobi会员注册fdp埋点*/
            var regFromFdp = sessionStorage.getItem('regFromFdp') || '直接注册';
            sessionStorage.removeItem('regFromFdp');
            logMallFdp(
                'mall_mem_reg',
                {
                    mall_free_text_0: '账号注册', //注册方式	传入：账号注册、手机注册、邮箱注册
                    mall_free_text_1: regFromFdp, //注册来源	传入：直接注册，新客有礼，会员卡，会员储值
                    mall_free_bool_0: data.success, //是否注册成功	成功=1，失败=0
                    mall_free_text_2: data.success
                        ? ''
                        : data.msg || data.rt + '', //失败原因	传入注册失败原因
                    mall_content_terminal: 'mobi',
                },
                true
            );
            if (data.success) {
                mallBuyLoginCheck();
                jm.cookie('loginMethod', loginMethod, { path: '/' }); //记录登录方式
                if (data.rt == 0) {
                    changeHref('/login.jsp?errno=-303');
                } else {
                    if (data.fromBind) {
                        memberActive(data.mail, data.memName);
                    } else {
                        if (data.active) {
                            memberActive(info.email, data.acct);
                        } else {
                            if (url.indexOf('javascript') == -1) {
                                changeHref(url);
                                return;
                            } else {
                                var methods = url.split(';');
                                for (var i = 0; i < methods.length - 1; i++) {
                                    var patt1 = new RegExp('[^script:]');
                                    if (patt1.test(url)) {
                                        var cells = methods[i].split(/:(.+)/);
                                        eval(cells[1]);
                                        if (
                                            url.indexOf(
                                                'PhotoDetailSwipeForJumpCtrl'
                                            ) != -1
                                        ) {
                                            window.klass.returnIndex =
                                                function () {
                                                    changeHref('/index.jsp');
                                                };
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            } else {
                changeValidateCode(jm('#signupCaptchaImg'));
                jm('#memberSignupCaptcha').val('');
                if (data.rt == -401) {
                    mobiIng(LS.memberSignupRegisterCaptchaNotMatch);
                } else if (data.rt == -601) {
                    mobiIng(LS.reGetMobileCode);
                } else if (data.rt == -8) {
                    mobiIng(LS.mobileHasSigned);
                } else if (data.rt == -6) {
                    mobiIng(LS.memberSignupRegisterExisted);
                } else if (data.rt == -4) {
                    mobiIng(LS.memberSignupRegisterLimit);
                } else if (data.rt == -3) {
                    mobiIng(LS.memberDialogNotFound);
                } else if (data.rt == -2) {
                    mobiIng(LS.mobileNumRegular);
                } else if (data.rt == otherLoginErrno.acctAlreadyBind) {
                    mobiIng(LS.memberOtherLgnAcctAlreadyBind);
                } else {
                    mobiIng(LS.memberSignupRegisterError);
                }
            }
        });
};

export const loginAcquireCode = function () {
    var acquirer = jm('#acquirerInput').val();
    if (isNull(acquirer) || !acquirer) {
        return false;
    }

    if (!jm.isMobile(acquirer)) {
        mobiIng(LS.mobileNumRegular);
        return false;
    }
    sendMobileLoginCode(acquirer)
        .catch(() => {
            mobiIng(LS.js_systemError);
        })
        .then((result) => {
            if (result.success) {
                loginAcquireCodeCountdown(60);
                jm('#memCodeSign').val(result.mobileCodeSign);
                Fai.top.tmpMobileCodeSgin = result.mobileCodeSign;
            } else {
                if (result.argErr) {
                    mobiIng(LS.memberDialogSendMobileClose);
                } else if (result.apiKeyNotFound) {
                    mobiIng(LS.memberDialogYunPianErr);
                } else if (result.tplNotFound) {
                    mobiIng(LS.memberDialogMobileTplErr);
                } else if (result.notFound) {
                    mobiIng(LS.memberDialogNotFound);
                } else if (result.limitOne) {
                    mobiIng(LS.getMobileOneMin);
                } else if (result.limitTwo) {
                    mobiIng(LS.getMobileHalfHour);
                } else if (result.noMoney) {
                    mobiIng(LS.memberDialogMobileMoneyErr);
                } else if (result.mobileErr) {
                    mobiIng(LS.memberDialogSendMobileCodeErr);
                } else if (result.sendLimit) {
                    mobiIng(LS.memberDialogSendMobileCodeLimit);
                } else if (result.mobileSysErr) {
                    mobiIng(LS.memberDialogSendMobileSysErr);
                } else if (result.tplNationErr) {
                    mobiIng(LS.mobileNationTplErr);
                } else if (result.systemErr) {
                    mobiIng(LS.js_systemError);
                } else if (result.rt == -301) {
                    mobiIng(LS.smsRanout);
                } else if (result.msg) {
                    mobiIng(result.msg);
                } else {
                    mobiIng(LS.js_argsError);
                }
            }
        });
};

const loginAcquireCodeCountdown = function (sec) {
    jm('#acquireCode').attr('countdown', '');
    var countdown = setInterval(function () {
        jm('#acquireCode').attr('countdown', sec); // countdown 用于点击后倒数计时不让点击
        jm('#acquireCode').text(jm.format(LS.reacquireMemCode, sec));
        if (sec < 0) {
            clearInterval(countdown);
            jm('#acquireCode').text(LS.memberDialogAcquireCode);
            jm('#acquireCode').attr('countdown', '');
        }
        sec--;
    }, 1000);
};

export const memberLogin = (
    url,
    mid,
    fid,
    fromMerchants,
    lotteryId,
    phoneNumber
) => {
    logDog(200061, 0);
    if (lotteryId) {
        jm.cookie('_lotteryId', lotteryId, { path: '/' });
    }
    if (phoneNumber) {
        jm.cookie('_phoneNumber', phoneNumber, { path: '/' });
    }
    if (Fai.top.isJuly3FreeUser) {
        logDog(200964, 2);
        mobiIng('免费版暂不支持此功能');
        return;
    }
    var acct = jm('#user').val();
    var pwd = jm('#password').val();

    if (mid != null && fid != null) {
        jm.cookie('_moduleid', mid, { path: '/' });
        jm.cookie('_fileid', fid, { path: '/' });
    }

    if (acct == null || acct == '') {
        showMemberLoginMsg(1, false);
        return;
    }
    if (pwd == null || pwd == '') {
        showMemberLoginMsg(2, false);
        return;
    }
    pwd = jm.md5(pwd);
    var loginBtn = jm('.loginSubmit');
    loginBtn.attr('disabled', true);
    jm('.g_botton').removeClass('sendIcon');

    var autoLoginBtn = jm('#autoLogin');
    var autoLogin = false;
    if (autoLoginBtn && autoLoginBtn.prop('checked')) {
        autoLogin = true;
    }

    var bssKey = 'AKWWpqEHCAEQARoDWzFdIgnllJDkuJbmsJE';
    var loginAction = function (checkSign) {
        let option = {
            acct,
            pwd,
            autoLogin,
            fromMerchants,
        };
        if (checkSign) {
            option['bssKey'] = bssKey;
            option['checkSign'] = checkSign;
        }
        loginMember(option)
            .catch(() => {
                loginBtn.removeAttr('disabled');
                showMemberLoginMsg(-1, 'ajax net error');
                window.Monitor.logMonitor(6063, true);
            })
            .then(async (result) => {
                loginBtn.removeAttr('disabled');
                var loginMethod = jm.isEmail(acct)
                    ? '邮箱登录'
                    : '账号密码登录';

                /*会员登录结果埋点fdp*/
                logMallFdp(
                    'mall_mem_log_mall',
                    {
                        mall_free_text_0: loginMethod, //登录方式
                        mall_free_bool_0: result.success, //是否登录成功
                        mall_free_text_2: result.success
                            ? ''
                            : result.msg || result.rt + '', //失败原因
                        mall_free_bool_1: Fai.top._showFaiscoSideSupport, // 侧边技术支持展示
                        mall_free_bool_3: Fai.top._showFaiscoSupport, // 底部技术支持展示
                        mall_content_terminal: 'mobi', //商城终端
                    },
                    true
                );

                if (result.success) {
                    Mobi._needLoginFaitest = false;
                    window.Monitor.logMonitor(6059);
                    jm('#_TOKEN').attr('value') ||
                        jm('#g_web').append(
                            "<span id='_TOKEN' value='" +
                                result._TOKEN +
                                "'></span>"
                        );
                    await clueReuqestVm.authRecordLoginOther();
                    mallBuyLoginCheck();
                    jm.cookie('loginMethod', loginMethod, { path: '/' }); //记录登录方式
                    if (url.indexOf('javascript') == -1) {
                        if (Fai.top.loginMemberSucJumpUrlIllegality) {
                            url = './index.jsp';
                        }
                        changeHref(url);
                        return;
                    } else {
                        var methods = url.split(';');
                        for (var i = 0; i < methods.length - 1; i++) {
                            var patt1 = new RegExp('[^script:]');
                            if (patt1.test(url)) {
                                var cells = methods[i].split(/:(.+)/);
                                eval(cells[1]);

                                if (
                                    url.indexOf(
                                        'PhotoDetailSwipeForJumpCtrl'
                                    ) != -1
                                ) {
                                    window.klass.returnIndex = function () {
                                        changeHref('/index.jsp');
                                    };
                                }
                            }
                        }
                    }
                } else {
                    //如果是从子商户端登录。做相关处理
                    if (fromMerchants) {
                        //仅针对Auth.ErrnoLoginMember的ACCT_ERR、NO_AUTH、NO_MAIL_AUTH、PWD_ERR
                        //这几种情况下，会清除cookies中的_FSESSIONID
                        //因此这几种情况，需要用户重新去PC的子商户端重新扫码登录
                        if (
                            result.rt === -302 ||
                            result.rt === -303 ||
                            result.rt === -304 ||
                            result.rt === -305 ||
                            result.rt === -2004
                        ) {
                            window.location.href =
                                '/merchantResult.jsp?loginFail=true&loginRt=' +
                                result.rt;
                            return;
                        }
                    }

                    jm('.g_botton').addClass('sendIcon');
                    jm('.loginIcon ').hide();
                    if (result.active) {
                        //  Mobi.memberInactiveDialog(result.mail, result.memName);
                        mobiIng(LS.memberLoginMailActivation);
                        window.Monitor.logMonitor(6062, true);
                    } else if (result.rt == -2000) {
                        changeHref(
                            preprocessUrl({ path: '', oldPath: '' }) +
                                'login.jsp?errno=-307'
                        );
                        window.Monitor.logMonitor(6062, true);
                    } else {
                        window.Monitor.logMonitor(6063, true);
                        showMemberLoginMsg(result.rt, result.captcha);
                        if (result.captcha) {
                            Mobi._needLoginFaitest = true;
                            memberLogin(url, mid, fid, fromMerchants);
                        }
                    }
                }
            });
    };

    if (Mobi._needLoginFaitest) {
        // eslint-disable-next-line no-undef
        initFaitest(
            {
                bss: 1,
                bssKey,
            },
            function (checkSign) {
                loginAction(checkSign);
            }
        );
    } else {
        loginAction();
    }
};

export const changeValidateCode = function (obj, type) {
    jm(obj).attr(
        'src',
        'validateCode.jsp?' +
            Math.random() * 1000 +
            '&validateCodeRegType=' +
            type
    );
};

export const fastLogin = function (url, mid, fid, fromMerchants) {
    var acquirer = jm('#acquirerInput').val();
    var code = jm('#memCodeInput').val();
    var memCodeSign = jm('#memCodeSign').val();

    if (mid != null && fid != null) {
        jm.cookie('_moduleid', mid, { path: '/' });
        jm.cookie('_fileid', fid, { path: '/' });
    }

    if (acquirer == null || acquirer == '') {
        showMemberLoginMsg(4, false);
        return;
    }
    if (code == null || code == '') {
        showMemberLoginMsg(5, false);
        return;
    }

    var loginBtn = jm('.loginSubmit');
    loginBtn.attr('disabled', true);
    jm('.g_botton').removeClass('sendIcon');

    var autoLoginBtn = jm('#autoLogin');
    var autoLogin = false;
    if (autoLoginBtn && autoLoginBtn.prop('checked')) {
        autoLogin = true;
    }

    var bssKey = 'AP7hkeIECAEQARoEWzE4XSIJ5ZSQ5LiW5rCR';
    var fastLoginAction = function (checkSign) {
        let option = {
            memCode: code,
            memCodeSign,
            acquirer,
            mode: 'mobile',
            fromMerchants,
        };
        checkMobileCodeGeneral(option)
            .catch(() => {
                mobiIng(LS.js_systemError);
            })
            .then((result) => {
                if (result.success) {
                    var memId = result.memId;
                    let fastLoginOption = {
                        memId,
                        autoLogin,
                    };
                    if (checkSign) {
                        Object.assign(fastLoginOption, {
                            bssKey,
                            checkSign,
                        });
                    }
                    loginMemberByMobile(fastLoginOption)
                        .catch(() => {
                            loginBtn.removeAttr('disabled');
                            showMemberLoginMsg(-1, 'ajax net error');
                        })
                        .then(async (result) => {
                            loginBtn.removeAttr('disabled');
                            if (typeof result !== 'object') {
                                result = jm.parseJSON(result);
                            }
                            var loginMethod = '手机号验证登录';
                            logMallFdp(
                                'mall_mem_log_mall',
                                {
                                    mall_free_text_0: loginMethod, //登录方式
                                    mall_free_bool_0: result.success, //是否登录成功
                                    mall_free_text_2: result.success
                                        ? ''
                                        : result.msg || result.rt + '', //失败原因
                                    mall_free_bool_1:
                                        Fai.top._showFaiscoSideSupport, // 侧边技术支持展示
                                    mall_free_bool_3:
                                        Fai.top._showFaiscoSupport, // 底部技术支持展示
                                    mall_content_terminal: 'mobi', //商城终端
                                },
                                true
                            );
                            if (result.success) {
                                window.Monitor.logMonitor(6060);
                                jm('#_TOKEN').attr('value') ||
                                    jm('#g_web').append(
                                        "<span id='_TOKEN' value='" +
                                            result._TOKEN +
                                            "'></span>"
                                    );
                                await clueReuqestVm.authRecordLoginOther();
                                Mobi._needFLoginFaitest = false;
                                mallBuyLoginCheck();
                                jm.cookie('loginMethod', loginMethod, {
                                    path: '/',
                                }); //记录登录方式
                                if (url.indexOf('javascript') == -1) {
                                    changeHref(url);
                                    return;
                                } else {
                                    var methods = url.split(';');
                                    for (
                                        var i = 0;
                                        i < methods.length - 1;
                                        i++
                                    ) {
                                        var patt1 = new RegExp('[^script:]');
                                        if (patt1.test(url)) {
                                            var cells =
                                                methods[i].split(/:(.+)/);
                                            eval(cells[1]);
                                            if (
                                                url.indexOf(
                                                    'PhotoDetailSwipeForJumpCtrl'
                                                ) != -1
                                            ) {
                                                window.klass.returnIndex =
                                                    function () {
                                                        changeHref(
                                                            '/index.jsp'
                                                        );
                                                    };
                                            }
                                        }
                                    }
                                }
                            } else {
                                if (fromMerchants) {
                                    //仅针对Auth.ErrnoLoginMember的ACCT_ERR、NO_AUTH、NO_MAIL_AUTH、PWD_ERR
                                    //这几种情况下，会清除cookies中的_FSESSIONID
                                    //因此这几种情况，需要用户重新去PC的子商户端重新扫码登录
                                    if (
                                        result.rt === -302 ||
                                        result.rt === -303 ||
                                        result.rt === -304 ||
                                        result.rt === -305
                                    ) {
                                        window.location.href =
                                            '/merchantResult.jsp?loginFail=true&loginRt=' +
                                            result.rt;
                                        return;
                                    }
                                }

                                jm('.g_botton').addClass('sendIcon');
                                jm('.loginIcon ').hide();
                                if (result.active) {
                                    mobiIng(LS.memberLoginMailActivation);
                                } else if (result.rt == -2000) {
                                    changeHref(
                                        preprocessUrl({
                                            path: '',
                                            oldPath: '',
                                        }) + 'login.jsp?errno=-307'
                                    );
                                } else {
                                    showMemberLoginMsg(
                                        result.rt,
                                        result.captcha
                                    );
                                    if (result.captcha) {
                                        Mobi._needFLoginFaitest = true;
                                        fastLogin(url, mid, fid, fromMerchants);
                                    }
                                }
                            }
                        });
                } else {
                    if (result.notFound) {
                        mobiIng(LS.memberDialogNotFound, true);
                    } else if (result.rt == -2000) {
                        changeHref(
                            preprocessUrl({ path: '', oldPath: '' }) +
                                'login.jsp?errno=-307'
                        );
                    } else if (result.rt == 1) {
                        mobiIng(LS.memberSignupRegisterCaptchaNotMatch);
                    }
                }
            });
    };

    if (Mobi._needFLoginFaitest) {
        // eslint-disable-next-line no-undef
        initFaitest(
            {
                bss: 1,
                bssKey,
            },
            function (checkSign) {
                fastLoginAction(checkSign);
            }
        );
    } else {
        fastLoginAction();
    }
};

export const mobileFastLoginToggle = function () {
    jm('.forAcctLogin').hide();
    jm('.forFastLogin').show();
    jm('.forFastLogin').css('display', 'inline-block');
};

export const acctLoginToggle = function () {
    jm('.forAcctLogin').show();
    jm('.forFastLogin').hide();
    jm('.forAcctLogin').css('display', 'inline-block');
};

export const initQQLogin = function (
    appKey,
    reUri,
    optionList,
    noRemark,
    remarkMaxLen,
    id,
    aesKey,
    returnUrl
) {
    jm('#' + id)
        .off('click')
        .on('click', function () {
            //将密钥存入cookie中
            jm.cookie('_qqLoginKey', aesKey, { expires: 1, path: '/' });
            //reUri = "http://m.chenyixin.iii.cc.cyx.dev.cc.dev.faidev.cc";
            localStorage.setItem('qqReturnUrl', returnUrl || '');
            window.location.href =
                '//graph.qq.com/oauth2.0/authorize?client_id=' +
                appKey +
                '&redirect_uri=' +
                reUri +
                '/qqLogin.jsp&display=mobile&response_type=token&scope=all';
        });
};

export const initWBLogin = function (
    appKey,
    reUri,
    optionList,
    noRemark,
    remarkMaxLen,
    id,
    aesKey
) {
    jm('#' + id).click(function () {
        //将密钥存入cookie中
        jm.cookie('_wbLoginKey', aesKey, { expires: 1, path: '/' });
        //reUri = "http://m.chenyixin.iii.cc.cyx.dev.cc.dev.faidev.cc";
        window.location.href =
            '//api.weibo.com/oauth2/authorize?client_id=' +
            appKey +
            '&redirect_uri=' +
            reUri +
            '/wbLogin.jsp&display=mobile&response_type=code';
    });
};

export const wxLogin = function (
    id,
    aid,
    lanCode,
    authUrl,
    appId,
    encryptKey,
    aesKey,
    _manageMode,
    _siteDemo,
    migrateWJZ,
    secondAuth,
    authLogin,
    returnUrl
) {
    jm('#' + id).on('click', function () {
        jm('#' + id).off('click');
        logDog(200061, 1);
        if (migrateWJZ) {
            mobiIng('系统维护中', true);
            return;
        }
        if (appId == 'wxb98d3675b04fbc2f') {
            logDog(200314, aid);
        }
        if (VITE_APP_MODE !== 'visitor') {
            mobiIng('请在手机预览实际效果', true);
            return;
        }
        if (_siteDemo) {
            mobiIng('样板网站无法登录', true);
            return;
        }
        jm.cookie('_wxLoginKey', aesKey, { expires: 1, path: '/' });
        var wxUrl =
            '/' +
            lanCode +
            '/mobiWxLoginConfirm.jsp?returnUrl=' +
            encodeURIComponent(returnUrl) +
            '&_key=' +
            aesKey;
        window.location.replace(wxUrl);
    });
};

export const checkHaveMultipleMember = function (authType) {
    //登录类型是 账号/手机或账号/邮箱(来自MemberDef.Info.AUTH_TYPE)
    jm('#user').on('blur', function () {
        var id = '#user';
        checkFun(id);
    });

    jm('#acquirerInput').on('blur', function () {
        var id = '#acquirerInput';
        checkFun(id);
    });

    var checkFun = function (id) {
        if (authType == 3 || authType == 4) {
            var acctVal = jm(id).val();
            var isEmail = jm.isEmail(acctVal);
            var isMobile = jm.isMobile(acctVal);
            var content = LS.mobiMultipleMemberMobileMsg;
            if (isEmail) {
                content = LS.mobiMultipleMemberEmailMsg;
            }
            if (isEmail || isMobile) {
                checkHaveMultipleMemberAjax(authType, acctVal)
                    .catch(() => {
                        showMemberLoginMsg(-1, 'ajax net error');
                    })
                    .then((result) => {
                        if (result.success) {
                            if (result.isMultipleMember) {
                                //显示弹窗
                                var options = {
                                    cancelClass: 'acctlogin',
                                    textClass: 'acctlogin',
                                    content,
                                    insertSelector: '#g_body',
                                    callback() {
                                        acctLoginToggle();
                                        jm(id).val('');
                                    },
                                };
                                prompt(options);
                            }
                        }
                    });
            }
        }
    };
};

export const manageLoginV3 = function () {
    var qqLgnPanel = jm('.qqLgnPanel');
    var sinaLgnPanel = jm('.sinaLgnPanel');
    var wxLgnPanel = jm('.wxLgnPanel');

    if (isVisitor()) {
        if (wxLgnPanel.css('display') == 'none') {
            if (
                qqLgnPanel.length == 0 &&
                sinaLgnPanel.length > 0 &&
                wxLgnPanel.length == 0
            ) {
                sinaLgnPanel.css('margin-left', '0');
            } else if (
                qqLgnPanel.length > 0 &&
                sinaLgnPanel.length == 0 &&
                wxLgnPanel.length == 0
            ) {
                qqLgnPanel.css('margin-left', '0');
            } else if (
                qqLgnPanel.length == 0 &&
                sinaLgnPanel.length == 0 &&
                wxLgnPanel.length > 0
            ) {
                wxLgnPanel.css('margin-left', '0');
            } else if (
                qqLgnPanel.length == 0 &&
                sinaLgnPanel.length > 0 &&
                wxLgnPanel.length > 0
            ) {
                sinaLgnPanel.css('margin-left', '0');
            } else if (
                qqLgnPanel.length > 0 &&
                sinaLgnPanel.length == 0 &&
                wxLgnPanel.length > 0
            ) {
                qqLgnPanel.css('margin-left', '0');
            }
        } else {
            if (
                qqLgnPanel.length > 0 &&
                sinaLgnPanel.length > 0 &&
                wxLgnPanel.length > 0
            ) {
                qqLgnPanel.css('margin-left', '0');
            } else if (
                qqLgnPanel.length > 0 &&
                sinaLgnPanel.length == 0 &&
                wxLgnPanel.length > 0
            ) {
                qqLgnPanel.css('margin-left', '0');
            } else if (
                qqLgnPanel.length == 0 &&
                sinaLgnPanel.length > 0 &&
                wxLgnPanel.length > 0
            ) {
                sinaLgnPanel.css('margin-left', '0');
            } else if (
                qqLgnPanel.length == 0 &&
                sinaLgnPanel.length == 0 &&
                wxLgnPanel.length > 0
            ) {
                wxLgnPanel.css('margin-left', '0');
            }
        }
        return;
    }

    jm('.wxLgnPanel').css('display', 'flex');
    if (
        qqLgnPanel.length > 0 &&
        sinaLgnPanel.length > 0 &&
        wxLgnPanel.length > 0
    ) {
        qqLgnPanel.css('margin-left', '0rem');
    } else if (
        qqLgnPanel.length > 0 &&
        sinaLgnPanel.length == 0 &&
        wxLgnPanel.length > 0
    ) {
        qqLgnPanel.css('margin-left', '0rem');
    } else if (
        qqLgnPanel.length == 0 &&
        sinaLgnPanel.length > 0 &&
        wxLgnPanel.length > 0
    ) {
        sinaLgnPanel.css('margin-left', '0rem');
    } else if (
        qqLgnPanel.length == 0 &&
        sinaLgnPanel.length > 0 &&
        wxLgnPanel.length == 0
    ) {
        sinaLgnPanel.css('margin-left', '0rem');
    } else if (
        qqLgnPanel.length > 0 &&
        sinaLgnPanel.length == 0 &&
        wxLgnPanel.length == 0
    ) {
        qqLgnPanel.css('margin-left', '0rem');
    } else if (
        qqLgnPanel.length == 0 &&
        sinaLgnPanel.length == 0 &&
        wxLgnPanel.length > 0
    ) {
        wxLgnPanel.css('margin-left', '0rem');
    }
    if (jm('.loginContent').find('.notice').length > 0) {
        return;
    }
    if (qqLgnPanel.length > 0) {
        qqLgnPanel
            .find('#qqLgn')
            .unbind()
            .click(function () {
                mobiIng(
                    '第三方登录需要在手机上使用。请用手机扫一扫，再尝试该功能。',
                    true
                );
            });
    }
    if (sinaLgnPanel.length > 0) {
        sinaLgnPanel
            .find('#sinaLgn')
            .unbind()
            .click(function () {
                mobiIng(
                    '第三方登录需要在手机上使用。请用手机扫一扫，再尝试该功能。',
                    true
                );
            });
    }
    if (wxLgnPanel.length > 0) {
        wxLgnPanel
            .find('#wxLgn')
            .unbind()
            .click(function () {
                mobiIng(
                    '第三方登录需要在手机上使用。请用手机扫一扫，再尝试该功能。',
                    true
                );
            });
    }
};

export const manageLogin = function () {
    var qqLgnPanel = jm('.qqLgnPanel');
    var sinaLgnPanel = jm('.sinaLgnPanel');
    var wxLgnPanel = jm('.wxLgnPanel');
    if (isVisitor()) {
        if (
            Fai.top._templateFrameId == 2001 ||
            Fai.top._templateFrameId == 2003 ||
            Fai.top._templateFrameId == 2004
        ) {
            if (wxLgnPanel.css('display') == 'none') {
                if (
                    qqLgnPanel.length == 0 &&
                    sinaLgnPanel.length > 0 &&
                    wxLgnPanel.length == 0
                ) {
                    sinaLgnPanel.css('margin-left', '4.7rem');
                } else if (
                    qqLgnPanel.length > 0 &&
                    sinaLgnPanel.length == 0 &&
                    wxLgnPanel.length == 0
                ) {
                    qqLgnPanel.css('margin-left', '4.7rem');
                } else if (
                    qqLgnPanel.length == 0 &&
                    sinaLgnPanel.length == 0 &&
                    wxLgnPanel.length > 0
                ) {
                    wxLgnPanel.css('margin-left', '4.7rem');
                } else if (
                    qqLgnPanel.length == 0 &&
                    sinaLgnPanel.length > 0 &&
                    wxLgnPanel.length > 0
                ) {
                    sinaLgnPanel.css('margin-left', '4.7rem');
                } else if (
                    qqLgnPanel.length > 0 &&
                    sinaLgnPanel.length == 0 &&
                    wxLgnPanel.length > 0
                ) {
                    qqLgnPanel.css('margin-left', '4.7rem');
                }
            } else {
                if (
                    qqLgnPanel.length > 0 &&
                    sinaLgnPanel.length > 0 &&
                    wxLgnPanel.length > 0
                ) {
                    qqLgnPanel.css('margin-left', '0.5rem');
                } else if (
                    qqLgnPanel.length > 0 &&
                    sinaLgnPanel.length == 0 &&
                    wxLgnPanel.length > 0
                ) {
                    qqLgnPanel.css('margin-left', '2.4rem');
                } else if (
                    qqLgnPanel.length == 0 &&
                    sinaLgnPanel.length > 0 &&
                    wxLgnPanel.length > 0
                ) {
                    sinaLgnPanel.css('margin-left', '2.4rem');
                } else if (
                    qqLgnPanel.length == 0 &&
                    sinaLgnPanel.length == 0 &&
                    wxLgnPanel.length > 0
                ) {
                    wxLgnPanel.css('margin-left', '4.7rem');
                }
            }
        }
        return;
    }

    jm('.wxLgnPanel').show();
    var ss = false;
    if (
        Fai.top._templateFrameId == 2001 ||
        Fai.top._templateFrameId == 2003 ||
        Fai.top._templateFrameId == 2004
    ) {
        ss = true;
    }
    if (
        qqLgnPanel.length > 0 &&
        sinaLgnPanel.length > 0 &&
        wxLgnPanel.length > 0
    ) {
        if (ss) {
            qqLgnPanel.css('margin-left', '0.5rem');
        } else {
            qqLgnPanel.css('margin-left', '1.8rem');
        }
    } else if (
        qqLgnPanel.length > 0 &&
        sinaLgnPanel.length == 0 &&
        wxLgnPanel.length > 0
    ) {
        if (ss) {
            qqLgnPanel.css('margin-left', '2.4rem');
        } else {
            qqLgnPanel.css('margin-left', '3.6rem');
        }
    } else if (
        qqLgnPanel.length == 0 &&
        sinaLgnPanel.length > 0 &&
        wxLgnPanel.length > 0
    ) {
        if (ss) {
            sinaLgnPanel.css('margin-left', '2.4rem');
        } else {
            sinaLgnPanel.css('margin-left', '3.6rem');
        }
    } else if (
        qqLgnPanel.length == 0 &&
        sinaLgnPanel.length > 0 &&
        wxLgnPanel.length == 0
    ) {
        if (ss) {
            sinaLgnPanel.css('margin-left', '4.7rem');
        } else {
            sinaLgnPanel.css('margin-left', '6rem');
        }
    } else if (
        qqLgnPanel.length > 0 &&
        sinaLgnPanel.length == 0 &&
        wxLgnPanel.length == 0
    ) {
        if (ss) {
            qqLgnPanel.css('margin-left', '4.7rem');
        } else {
            qqLgnPanel.css('margin-left', '6rem');
        }
    } else if (
        qqLgnPanel.length == 0 &&
        sinaLgnPanel.length == 0 &&
        wxLgnPanel.length > 0
    ) {
        if (ss) {
            wxLgnPanel.css('margin-left', '4.7rem');
        } else {
            wxLgnPanel.css('margin-left', '6rem');
        }
    }
    if (jm('.loginContent').find('.notice').length > 0) {
        return;
    }
    if (qqLgnPanel.length > 0) {
        qqLgnPanel
            .find('#qqLgn')
            .unbind()
            .click(function () {
                mobiIng(
                    '第三方登录需要在手机上使用。请用手机扫一扫，再尝试该功能。',
                    true
                );
            });
    }
    if (sinaLgnPanel.length > 0) {
        sinaLgnPanel
            .find('#sinaLgn')
            .unbind()
            .click(function () {
                mobiIng(
                    '第三方登录需要在手机上使用。请用手机扫一扫，再尝试该功能。',
                    true
                );
            });
    }
    if (wxLgnPanel.length > 0) {
        wxLgnPanel
            .find('#wxLgn')
            .unbind()
            .click(function () {
                mobiIng(
                    '第三方登录需要在手机上使用。请用手机扫一扫，再尝试该功能。',
                    true
                );
            });
    }
};

// 点击第三方登录图标之后  选择绑定已有账号登录或者直接登录页面
export const memberOtherBindOrLogin = function (
    optionList,
    noRemark,
    remarkMaxLen,
    uid,
    uname,
    avator,
    loginType,
    url,
    faiOpenIdGreen,
    faiOpenId
) {
    var divHtml = [];
    var sendBtnV3 = Fai.top._openThemeV3 ? ' g_main_bgColor_v3 fpw_btn ' : '';
    divHtml.push("<div style='height:7.38rem;'>");

    divHtml.push(
        "<div class='avator loginAvatorCircle' style='background-image:url(" +
            avator +
            ");'></div>"
    );
    divHtml.push(
        "<div class='userName' style='margin-top:0.5rem; text-align: center;'>" +
            uname +
            '</div>'
    );
    divHtml.push('</div>');
    divHtml.push("<div class='remarkCon'>");
    divHtml.push("<div class='remarkLine'></div>");
    divHtml.push('</div>');

    divHtml.push(
        "<div class='signupSubmitCtrl g_globalLine' style='margin-top:0.6rem;'>"
    );
    divHtml.push(
        "<input type='button' id='acctFirst'  class='g_button sendIcon signupSubmit submitIcon " +
            sendBtnV3 +
            "' value='" +
            LS.memberOtherLgnBindAcct +
            "'/>"
    );
    // bindOtherAcctFirst(loginType, uid, faiOpenIdGreen, faiOpenId)
    divHtml.push('</div>');

    divHtml.push(
        "<div class='signupSubmitCtrl g_globalLine' style='margin-top:0.78rem;'>"
    );
    if (loginType == 'other_qq') {
        divHtml.push(
            "<input type='button' id='other_qq' class='g_button sendIcon signupSubmit submitIcon g_mainColor g_main_color_v3' style='background:rgb(240,240,245);border:1px solid;' value='" +
                LS.memberOtherLgnNow +
                "'/>"
        );
        // qqWinListener(optionList, noRemark, remarkMaxLen, uid, uname, avator, url)
    } else if (loginType == 'other_wb') {
        divHtml.push(
            "<input type='button' id='other_wb'  class='g_button sendIcon signupSubmit submitIcon g_mainColor g_main_color_v3' style='background:rgb(240,240,245);border:1px solid;' value='" +
                LS.memberOtherLgnNow +
                "'/>"
        );
        // wbWinListener(optionList, noRemark, remarkMaxLen, uid, uname, avator, url);
    } else if (loginType == 'other_wx') {
        divHtml.push(
            "<input type='button' id='other_wx' class='g_button sendIcon signupSubmit submitIcon g_mainColor g_main_color_v3' style='background:rgb(240,240,245);border:1px solid;' value='" +
                LS.memberOtherLgnNow +
                "'/>"
        );
        // wxOpenIdLogin(optionList, noRemark, remarkMaxLen, uid, uname, avator, url, faiOpenIdGreen, faiOpenId)
    }

    divHtml.push('</div>');

    jm('#bindOrLogin')
        .parents('.g_web, .middleCenter')
        .css('background', '#f0f0f5');
    if (Fai.top._openThemeV3) {
        jm('#bindOrLogin')
            .parents('.g_web, .middleCenter')
            .css('background', '#ffffff');
    }
    if (!jm('#bindOrLogin .loginContent').children().length) {
        jm('#bindOrLogin .loginContent').append(divHtml.join(''));
    }

    jm('#acctFirst')
        .unbind('click')
        .bind('click', () => {
            bindOtherAcctFirst(loginType, uid, faiOpenIdGreen, faiOpenId);
        });
    if (loginType == 'other_qq') {
        jm('#other_qq')
            .unbind('click')
            .bind('click', () => {
                qqWinListener(
                    optionList,
                    noRemark,
                    remarkMaxLen,
                    uid,
                    uname,
                    avator,
                    url
                );
            });
    } else if (loginType == 'other_wb') {
        jm('#other_wb')
            .unbind('click')
            .bind('click', () => {
                wbWinListener(
                    optionList,
                    noRemark,
                    remarkMaxLen,
                    uid,
                    uname,
                    avator,
                    url
                );
            });
    } else if (loginType == 'other_wx') {
        jm('#other_wx')
            .unbind('click')
            .bind('click', () => {
                wxOpenIdLogin(
                    optionList,
                    noRemark,
                    remarkMaxLen,
                    uid,
                    uname,
                    avator,
                    url,
                    faiOpenIdGreen,
                    faiOpenId
                );
            });
    }

    jm('#mLogin').hide();
    jm('#bindOrLogin').show();
    jm('#bindOrLogin #bindOrLoginBack').click(function () {
        jm('#bindOrLogin').hide();
        jm('#mLogin').show();
    });
};

const bindOtherAcctFirst = (loginType, uid, faiOpenIdGreen, faiOpenId) => {
    var value = Fai.top._openThemeV3
        ? LS.memberOtherLgnBindNowV3
        : LS.memberOtherLgnBindNow;
    if (loginType == 'other_qq') {
        loginType = 1;
    } else if (loginType == 'other_wb') {
        loginType = 2;
    } else if (loginType == 'other_wx') {
        loginType = 4;
    }
    var bindV3 = Fai.top._openThemeV3 ? 'bindV3' : '';
    var sendBtnV3 = Fai.top._openThemeV3 ? ' g_main_bgColor_v3 fpw_btn ' : '';
    var divHtml = "<div class='g_globalLine " + bindV3 + "'>";
    divHtml +=
        "	<input type='text' maxlength='50'  id='bindUser' class='itemEdit g_input mustItem' placeholder='" +
        LS.memberSignupRegisterAcctEmpty +
        "'/><span class='icon-userIcon g_mainColor g_main_color_v3'></span>";
    divHtml += '</div>';
    divHtml += "<div class='g_globalLine " + bindV3 + "'>";
    divHtml +=
        "	<input type='password'maxlength='20' id='bindPassword' class='itemEdit g_input  mustItem' placeholder='" +
        LS.memberDialogPleaseEnterPwd +
        "'/><span class='icon-pswIcon g_mainColor g_main_color_v3'></span>";
    divHtml += '</div>';
    divHtml += "<div class='g_globalLine " + bindV3 + "'>";
    divHtml +=
        "<input type='button' id='otherAcctFirst'  class=' g_button " +
        sendBtnV3 +
        " sendIcon' value='" +
        value +
        "'/>";
    divHtml += '</div>';

    if (!jm('#bindNow .loginContent').children().length) {
        jm('#bindNow .loginContent').append(divHtml);
    }
    jm('#otherAcctFirst')
        .unbind('click')
        .bind('click', () => {
            bindOtherAcctFirstSubmit(loginType, uid, faiOpenIdGreen, faiOpenId);
        });
    jm('#bindOrLogin').hide();
    jm('#bindNow').show();
    jm('#bindNow #bindNowBack').click(function () {
        jm('#bindNow').hide();
        jm('#bindOrLogin').show();
    });
};

export const qqWinListener = (
    optionList,
    noRemark,
    remarkMaxLen,
    q_uid,
    q_name,
    q_avator,
    url
) => {
    try {
        if (typeof optionList == 'string') {
            optionList = jm.parseJSON(optionList);
        }
        var hasMobile = checkHasMobileOption(optionList);
        var otherLoginMust = false; //判断是否有第三方登录需要填写的会员资料项
        if (optionList) {
            for (var i = 0; i < optionList.length; i++) {
                if (optionList[i]['otherLoginMust']) {
                    otherLoginMust = true;
                    break;
                }
            }
        }
        let dataOption = {
            loginType: 1,
            openId: q_uid,
            hasMobile,
            otherLoginMust,
        };
        if (!otherLoginMust) {
            Object.assign(dataOption, {
                avator: q_avator,
                name: q_name,
            });
        }

        otherLoginMember(dataOption)
            .catch(() => {
                logErr('Mobi.qqWinListener -> otherLoginMember ajax error');
                mobiIng(LS.memberLoginError, true);
            })
            .then(async (result) => {
                /*会员登录结果埋点fdp*/
                let loginMethod = 'qq登录';
                if (result.success || result.rt != -3) {
                    if (result.isReg) {
                        //新增的会员
                        var regFromFdp =
                            sessionStorage.getItem('regFromFdp') || '直接注册';
                        sessionStorage.removeItem('regFromFdp');
                        logMallFdp(
                            'mall_mem_reg',
                            {
                                mall_third_login: loginMethod, //第三方登录	传入：微信登录、QQ登录、微博登录
                                mall_free_text_1: regFromFdp, //注册来源	传入：直接注册，新客有礼
                                mall_free_bool_0: result.success, //是否注册成功	成功=1，失败=0
                                mall_free_text_2: result.success
                                    ? ''
                                    : result.msg || result.rt + '', //失败原因	传入注册失败原因
                                mall_content_terminal: 'mobi',
                            },
                            true
                        );
                    } else {
                        logMallFdp(
                            'mall_mem_log_mall',
                            {
                                mall_free_text_0: loginMethod, //登录方式
                                mall_free_bool_0: result.success, //是否登录成功
                                mall_free_text_2: result.success
                                    ? ''
                                    : result.msg || result.rt + '', //失败原因
                                mall_free_bool_1:
                                    Fai.top._showFaiscoSideSupport, // 侧边技术支持展示
                                mall_free_bool_3: Fai.top._showFaiscoSupport, // 底部技术支持展示
                                mall_content_terminal: 'mobi', //商城终端
                            },
                            true
                        );
                    }
                }

                if (result.success) {
                    window.Monitor.logMonitor(6061);
                    await clueReuqestVm.authRecordLoginOther();
                    mallBuyLoginCheck();
                    jm.cookie('loginMethod', loginMethod, { path: '/' }); //记录登录方式
                    if (url.indexOf('javascript') == -1) {
                        if (url == '/login.jsp') {
                            changeHref('/index.jsp');
                        } else {
                            changeHref(url);
                        }
                        return;
                    } else {
                        var methods = url.split(';');
                        for (var i = 0; i < methods.length - 1; i++) {
                            var patt1 = new RegExp('[^script:]');
                            if (patt1.test(url)) {
                                var cells = methods[i].split(/:(.+)/);
                                eval(cells[1]);
                                if (
                                    url.indexOf(
                                        'PhotoDetailSwipeForJumpCtrl'
                                    ) != -1
                                ) {
                                    window.klass.returnIndex = function () {
                                        changeHref('/index.jsp');
                                    };
                                }
                            }
                        }
                    }
                } else {
                    if (result.active) {
                        memberActive(result.mail, result.memName);
                    } else if (result.rt == -3) {
                        memberOtherLoginFill(
                            optionList,
                            q_name,
                            q_uid,
                            q_avator,
                            1,
                            result.mobileCtNameList,
                            result.signNeenMobile,
                            url
                        );
                    } else if (result.rt == -303) {
                        mobiIng(LS.memberNoAuth, true);
                    } else {
                        mobiIng(LS.js_argsError, true);
                    }
                }
            });
    } catch (e) {
        loginLog({ type: 'qqWinListener', data: e.toString() });
    }
};

export const wbWinListener = (
    optionList,
    noRemark,
    remarkMaxLen,
    w_uid,
    w_name,
    w_avator,
    url
) => {
    if (typeof optionList == 'string') {
        optionList = jm.parseJSON(optionList);
    }
    var hasMobile = checkHasMobileOption(optionList);
    var otherLoginMust = false; //判断是否有第三方登录需要填写的会员资料项
    if (optionList) {
        for (var i = 0; i < optionList.length; i++) {
            if (optionList[i]['otherLoginMust']) {
                otherLoginMust = true;
                break;
            }
        }
    }
    let dataOption = {
        loginType: 2,
        openId: w_uid,
        hasMobile,
        otherLoginMust,
    };

    if (!otherLoginMust) {
        Object.assign(dataOption, {
            avator: w_avator,
            name: w_name,
        });
    }

    otherLoginMember(dataOption)
        .catch(() => {
            logErr('Mobi.wbWinListener -> otherLoginMember ajax error');
            mobiIng(LS.memberLoginError, true);
        })
        .then(async (result) => {
            /*会员登录结果埋点fdp*/
            var loginMethod = '微博登录';
            if (result.success || result.rt != -3) {
                if (result.isReg) {
                    //新增的会员
                    var regFromFdp =
                        sessionStorage.getItem('regFromFdp') || '直接注册';
                    sessionStorage.removeItem('regFromFdp');
                    logMallFdp(
                        'mall_mem_reg',
                        {
                            mall_third_login: loginMethod, //第三方登录	传入：微信登录、QQ登录、微博登录
                            mall_free_text_1: regFromFdp, //注册来源	传入：直接注册，新客有礼
                            mall_free_bool_0: result.success, //是否注册成功	成功=1，失败=0
                            mall_free_text_2: result.success
                                ? ''
                                : result.msg || result.rt + '', //失败原因	传入注册失败原因
                            mall_content_terminal: 'mobi',
                        },
                        true
                    );
                } else {
                    logMallFdp(
                        'mall_mem_log_mall',
                        {
                            mall_free_text_0: loginMethod, //登录方式
                            mall_free_bool_0: result.success, //是否登录成功
                            mall_free_text_2: result.success
                                ? ''
                                : result.msg || result.rt + '', //失败原因
                            mall_free_bool_1: Fai.top._showFaiscoSideSupport, // 侧边技术支持展示
                            mall_free_bool_3: Fai.top._showFaiscoSupport, // 底部技术支持展示
                            mall_content_terminal: 'mobi', //商城终端
                        },
                        true
                    );
                }
            }
            if (result.success) {
                window.Monitor.logMonitor(6061);
                await clueReuqestVm.authRecordLoginOther();
                mallBuyLoginCheck();
                jm.cookie('loginMethod', loginMethod, { path: '/' }); //记录登录方式
                if (url == '/login.jsp') {
                    changeHref('/index.jsp');
                } else {
                    changeHref(url);
                }
                return;
            } else {
                if (result.active) {
                    memberActive(result.mail, result.memName);
                } else if (result.rt == -3) {
                    memberOtherLoginFill(
                        optionList,
                        w_name,
                        w_uid,
                        w_avator,
                        2,
                        result.mobileCtNameList,
                        result.signNeenMobile,
                        url
                    );
                } else if (result.rt == -303) {
                    mobiIng(LS.memberNoAuth, true);
                } else {
                    mobiIng(LS.js_argsError, true);
                }
            }
        });
};

export const wxOpenIdLogin = (
    optionList,
    noRemark,
    remarkMaxLen,
    openId,
    nickName,
    headImg,
    url,
    faiOpenIdGreen,
    faiOpenId
) => {
    let _aid = window._aid;
    try {
        let logAidList = [
            1591627, 24784076, 16835847, 15546092, 14346383, 24418638, 24434187,
            20343605, 23140239, 13940875,
        ];
        if (logAidList.includes(_aid)) {
            loginLog({
                type: _aid + '-wxWinListener-js-1',
                data:
                    encodeURIComponent(faiOpenId) +
                    '__' +
                    encodeURIComponent(nickName) +
                    '__' +
                    encodeURIComponent(headImg),
            });
        }

        if (typeof optionList == 'string') {
            optionList = jm.parseJSON(optionList);
            if (logAidList.includes(_aid)) {
                loginLog({
                    type: _aid + '-wxWinListener-js-2',
                    data: 'optionList',
                });
            }
        }
        var hasMobile = checkHasMobileOption(optionList);
        var otherLoginMust = false; //判断是否有第三方登录需要填写的会员资料项
        if (optionList) {
            if (logAidList.includes(_aid)) {
                loginLog({
                    type: _aid + '-wxWinListener-js-5',
                    data: 'optionList',
                });
            }
            for (var i = 0; i < optionList.length; i++) {
                if (optionList[i]['otherLoginMust']) {
                    otherLoginMust = true;
                    break;
                }
            }
        }

        if (logAidList.includes(_aid)) {
            loginLog({
                type: _aid + '-wxWinListener-js-6',
                data: 'optionList',
            });
        }

        var unionId = '';
        if (typeof Mobi.w_unionId != 'undefined' && Mobi.w_unionId) {
            unionId = Mobi.w_unionId;
        }

        let dataOption = {};
        if (faiOpenIdGreen) {
            dataOption = {
                loginType: 5,
                hasMobile,
                otherLoginMust,
                faiOpenIdGreen,
                faiOpenId,
            };
        } else {
            dataOption = {
                loginType: 4,
                hasMobile,
                otherLoginMust,
                openId,
                faiOpenId,
                faiOpenIdGreen,
                unionId,
            };
        }

        if (!otherLoginMust) {
            Object.assign(dataOption, {
                avator: headImg,
                name: nickName,
            });
        }

        otherLoginMember(dataOption)
            .catch(() => {
                logErr('Mobi.wxOpenIdLogin -> otherLoginMember ajax error');
                mobiIng(LS.memberLoginError, true);
            })
            .then(async (result) => {
                if (result.success || result.rt != -3) {
                    var loginMethod = '微信登录';
                    if (result.isReg) {
                        //新增的会员
                        var regFromFdp =
                            sessionStorage.getItem('regFromFdp') || '直接注册';
                        sessionStorage.removeItem('regFromFdp');
                        logMallFdp(
                            'mall_mem_reg',
                            {
                                mall_third_login: loginMethod, //第三方登录	传入：微信登录、QQ登录、微博登录
                                mall_free_text_1: regFromFdp, //注册来源	传入：直接注册，新客有礼
                                mall_free_bool_0: result.success, //是否注册成功	成功=1，失败=0
                                mall_free_text_2: result.success
                                    ? ''
                                    : result.msg || result.rt + '', //失败原因	传入注册失败原因
                                mall_content_terminal: 'mobi',
                            },
                            true
                        );
                    } else {
                        logMallFdp(
                            'mall_mem_log_mall',
                            {
                                mall_free_text_0: loginMethod, //登录方式
                                mall_free_bool_0: result.success, //是否登录成功
                                mall_free_text_2: result.success
                                    ? ''
                                    : result.msg || result.rt + '', //失败原因
                                mall_free_bool_1:
                                    Fai.top._showFaiscoSideSupport, // 侧边技术支持展示
                                mall_free_bool_3: Fai.top._showFaiscoSupport, // 底部技术支持展示
                                mall_content_terminal: 'mobi', //商城终端
                            },
                            true
                        );
                    }
                }

                if (result.success) {
                    jm('head').append(
                        "<meta id='_TOKEN' value='" + result._TOKEN + "'>"
                    );
                    await clueReuqestVm?.authRecordLoginWeChat();
                    window.Monitor.logMonitor(6061);
                    mallBuyLoginCheck();
                    jm.cookie('loginMethod', loginMethod, { path: '/' }); //记录登录方式
                    if (url.indexOf('javascript') == -1) {
                        if (url == '/login.jsp') {
                            changeHref('/index.jsp');
                        } else {
                            changeHref(url);
                        }
                        return;
                    } else {
                        var methods = url.split(';');
                        for (var i = 0; i < methods.length - 1; i++) {
                            var patt1 = new RegExp('[^script:]');
                            if (patt1.test(url)) {
                                var cells = methods[i].split(/:(.+)/);

                                eval(cells[1]);

                                if (
                                    url.indexOf(
                                        'PhotoDetailSwipeForJumpCtrl'
                                    ) != -1
                                ) {
                                    window.klass.returnIndex = function () {
                                        changeHref('/index.jsp');
                                    };
                                }
                            }
                        }
                    }
                } else {
                    if (result.active) {
                        memberActive(result.mail, result.memName);
                    } else if (result.rt == -3) {
                        if (typeof faiOpenId != 'undefined' && faiOpenId) {
                            memberOtherLoginFill(
                                optionList,
                                nickName,
                                openId,
                                headImg,
                                5,
                                result.mobileCtNameList,
                                result.signNeenMobile,
                                url,
                                faiOpenId
                            );
                        } else {
                            memberOtherLoginFill(
                                optionList,
                                nickName,
                                openId,
                                headImg,
                                4,
                                result.mobileCtNameList,
                                result.signNeenMobile,
                                url
                            );
                        }
                    } else if (result.rt == -303) {
                        changeHref(
                            preprocessUrl({ path: '', oldPath: '' }) +
                                '/login.jsp?errno=-303'
                        );
                    } else if (result.rt == -4) {
                        mobiIng(LS.memberSignupRegisterLimit);
                    } else {
                        mobiIng(LS.js_argsError, true);
                    }
                }
            });
    } catch (e) {
        loginLog({ type: _aid + '-wxWinListener-js-err', data: e.toString() });
    }
};

const memberOtherLoginFill = (
    optionList,
    name,
    openId,
    avator,
    loginType,
    mobileCtNameList,
    signNeenMobile,
    url,
    faiOpenId
) => {
    var otherLoginFillPic = Fai.top._openThemeV3
        ? 'otherLoginFillPicV3'
        : 'otherLoginFillPic';
    var otherLoginFillUser = Fai.top._openThemeV3
        ? 'otherLoginFillUserV3'
        : 'otherLoginFillUser';
    var phoneTip = Fai.top._openThemeV3 ? LS.mobileArea : LS.mobileAreaCode;
    var register_line = Fai.top._openThemeV3 ? ' register_line ' : ' ';
    var input_tip_v3 = Fai.top._openThemeV3 ? ' input_tip_v3 ' : ' ';
    var divHtml = [];
    divHtml.push("<div class='" + otherLoginFillPic + "'>");
    if (loginType == 1 || loginType == 4) {
        divHtml.push(
            "<div class='avator loginTypeAvator' style='background-image:url(" +
                avator +
                ");'></div>"
        );
    } else {
        divHtml.push(
            "<div class='avator otherLoginTypeAvator' style='background-image:url(" +
                avator +
                ");'></div>"
        );
    }

    divHtml.push(
        "<div class='userName " + otherLoginFillUser + "'>" + name + '</div>'
    );
    divHtml.push('</div>');
    divHtml.push("<div class='remarkCon'>");
    divHtml.push("<div class='remarkLine'></div>");
    divHtml.push(
        "<div class='remarkInfo'>" + LS.memberOtherLgnLastStep + '</div>'
    );
    divHtml.push('</div>');

    var tagWidth = '';
    if (checkHasMobileOption(optionList)) {
        tagWidth = 'tagWidth8';
    }
    var itemIcon = '';
    jm.each(optionList, function (i, n) {
        var customPropName = '';
        if (n.otherLoginMust) {
            if (n.fieldKey == 'email') {
                itemIcon = 'icon-emailIcon g_mainColor g_main_color_v3';
            } else if (n.fieldKey == 'name') {
                itemIcon = 'icon-nameIcon g_mainColor g_main_color_v3';
            } else {
                itemIcon = 'icon-customIcon g_mainColor g_main_color_v3';
                customPropName = 'customIcon';
            }
            var placeholder = '';
            if (n.placeholder == n.name) {
                placeholder = LS.memberOtherLgnPleaseInput + n.name;
            } else {
                placeholder = n.placeholder;
            }

            if (n.fieldKey == 'mobile') {
                divHtml.push(
                    "<div class='g_globalLine " +
                        register_line +
                        ' ' +
                        tagWidth +
                        "'>"
                );
                // 3.0手机和手机区号一行显示
                if (Fai.top._openThemeV3) {
                    if (n.must) {
                        divHtml.push(
                            "<input type='text' maxlength='50' id='mobile' name='" +
                                phoneTip +
                                "' style='width:65%' class='addCtTel itemEdit userAddItem g_input maxlength='11' loginTelInput ' placeholder='" +
                                placeholder +
                                LS.memberOtherLgnMust +
                                "'>"
                        );
                    } else {
                        divHtml.push(
                            "<input type='text' maxlength='50' id='mobile' name='" +
                                phoneTip +
                                "' style='width:65%' class='addCtTel itemEdit userAddItem g_input maxlength='11' loginTelInput ' placeholder='" +
                                placeholder +
                                "'>"
                        );
                    }
                }

                // 3.0手机区号新的手机下拉框
                if (Fai.top._openThemeV3) {
                    divHtml.push(
                        "<div class='mobileCtIcon otherSettingIcon icon-downward'></div>"
                    );
                    divHtml.push(
                        "<div class='g_input selectCover selectCoverRight'>+86</div>"
                    );
                    divHtml.push(
                        "<select id='mobileCt' name='mobileCt' class='itemEdit userAddItem g_select ' onchange='Mobi.fillPersInfoChangeMobileCt()'>"
                    );
                } else {
                    divHtml.push(
                        "<select id='mobileCt' name='mobileCt' class='itemEdit g_select'>"
                    );
                }

                for (var j = 0; j < mobileCtNameList.length; j++) {
                    divHtml.push(
                        "<option value='" +
                            mobileCtNameList[j]['ctName'] +
                            "'>" +
                            mobileCtNameList[j]['ctShowName'] +
                            mobileCtNameList[j]['ctCode'] +
                            '</option>'
                    );
                }
                divHtml.push('</select>');
                divHtml.push(
                    "<span class='" +
                        customPropName +
                        "'>" +
                        phoneTip +
                        '</span>'
                );
                divHtml.push('</div>');
            }

            if (n.dropDownType) {
                divHtml.push("<div class='g_globalLine " + tagWidth + "'>");
                if (Fai.top._openThemeV3) {
                    divHtml.push(
                        "<div class='mobileCtIcon otherSettingIcon icon-downward'></div>"
                    );
                    divHtml.push("<input class='g_input selectCover'>");
                }
                if (n.must) {
                    divHtml.push(
                        "<select id='" +
                            n.fieldKey +
                            "' name='" +
                            n.name +
                            "' class='itemEdit userAddItem isCheckUAI g_select' placeholder='" +
                            placeholder +
                            LS.memberOtherLgnMust +
                            "'>"
                    );
                    divHtml.push(
                        "<option value=''>" +
                            n.name +
                            LS.memberOtherLgnMust +
                            '</option>'
                    );
                } else {
                    divHtml.push(
                        "<select id='" +
                            n.fieldKey +
                            "' name='" +
                            n.name +
                            "' class='itemEdit userAddItem g_select' placeholder='" +
                            placeholder +
                            "'>"
                    );
                    divHtml.push("<option value=''>" + n.name + '</option>');
                }

                var propOptions = n.dropDownContent.split('&');
                for (let i = 0; i < propOptions.length; i++) {
                    divHtml.push(
                        "<option value='" +
                            propOptions[i] +
                            "'>" +
                            propOptions[i] +
                            '</option>'
                    );
                }
                divHtml.push(
                    "</select><span class='" +
                        itemIcon +
                        ' ' +
                        input_tip_v3 +
                        "'></span>"
                );
                if (customPropName != '') {
                    divHtml.push(
                        "<span class='" +
                            customPropName +
                            "'>" +
                            n.name +
                            '</span>'
                    );
                }
                divHtml.push('</div>');
            } else {
                if (
                    !Fai.top._openThemeV3 ||
                    (Fai.top._openThemeV3 && n.fieldKey != 'mobile')
                ) {
                    //3.0不需要重新输出手机号，因为手机号在上面和区号一行显示了
                    divHtml.push("<div class='g_globalLine " + tagWidth + "'>");
                    if (n.must) {
                        divHtml.push(
                            "<input type='text' maxlength='50' id='" +
                                n.fieldKey +
                                "' name='" +
                                n.name +
                                "' class='mustItem isCheckUAI itemEdit userAddItem  g_input' maxlength='50' placeholder='" +
                                placeholder +
                                LS.memberOtherLgnMust +
                                "'><span class='" +
                                itemIcon +
                                ' ' +
                                input_tip_v3 +
                                "'></span>"
                        );
                    } else {
                        divHtml.push(
                            "<input type='text' maxlength='50' id='" +
                                n.fieldKey +
                                "' name='" +
                                n.name +
                                "' class='mustItem itemEdit userAddItem  g_input' maxlength='50' placeholder='" +
                                placeholder +
                                "'><span class='" +
                                itemIcon +
                                ' ' +
                                input_tip_v3 +
                                "'></span>"
                        );
                    }

                    if (customPropName != '') {
                        divHtml.push(
                            "<span class='" +
                                customPropName +
                                "'>" +
                                n.name +
                                '</span>'
                        );
                    }
                    divHtml.push('</div>');
                }
            }
        }
    });
    if (signNeenMobile) {
        divHtml.push("<div class='g_globalLine'>");
        divHtml.push(
            "<input id='memberSignupCaptcha' type='text' class='captchaText g_input' maxlength='4' placeholder='" +
                LS.EnterVerificationCode +
                "'/><img id='signupCaptchaImg'  class='captchaImg' src='validateCode.jsp?" +
                Math.random() * 1000 +
                "' onclick='Mobi.changeValidateCode(jm(\"#signupCaptchaImg\"))' /><div style='clear:both'></div>"
        );
        if (Fai.top._openThemeV3) {
            divHtml.push(
                "<span class='fill_input_tip_v3'>" + LS.loginCode + '</span>'
            );
        }
        divHtml.push('</div>');

        divHtml.push("<div class='g_globalLine'>");
        divHtml.push(
            "<input id='messageAuthCode' type='text' class='captchaText g_input' maxlength='6' placeholder='" +
                LS.inputMobileCode +
                "' /><div id='messageAuthCodeClick' class='fk-sign-getMobileCode' title='" +
                LS.getMobileCode +
                "'>" +
                LS.getMobileCode +
                "</div><div style='clear:both'></div>"
        );
        if (Fai.top._openThemeV3) {
            divHtml.push(
                "<span class='fill_input_tip_v3'>" + LS.loginCode + '</span>'
            );
        }
        divHtml.push('</div>');
    }
    divHtml.push(
        "<div class='signupSubmitCtrl g_globalLine " +
            tagWidth +
            "' style='margin-top:1rem;'>"
    );
    divHtml.push(
        "<input type='button'  class='g_button sendIcon signupSubmit submitIcon fpw_btn g_main_bgColor_v3' value='" +
            LS.login +
            "'/>"
    );
    divHtml.push('</div>');

    jm('#fillAcctInfo')
        .parents('.g_web, .middleCenter')
        .css('background', '#f0f0f5');
    if (!jm('#fillAcctInfo .loginContent').children().length) {
        jm('#fillAcctInfo .loginContent').append(divHtml.join(''));
    }
    jm('#mLogin').hide();
    jm('#bindOrLogin').hide();
    jm('#fillAcctInfo').show();
    jm('#fillAcctInfo #fillInfoBack').click(function () {
        jm('#fillAcctInfo').hide();
        jm('#mLogin').show();
    });

    // 绑定事件
    jm('.signupSubmitCtrl .signupSubmit')
        .unbind('click')
        .bind('click', function () {
            memberOtherLoginSubmit(
                name,
                loginType,
                openId,
                url,
                avator,
                faiOpenId
            );
        });

    jm('.fk-sign-getMobileCode')
        .unbind('click')
        .bind('click', function () {
            getSignMobileCodeForFill();
        });

    if (Fai.top._openThemeV3) {
        jm('.jz_themeV3.mobiCol10 .g_web').css('background-color', '#ffffff');
        jm('.jz_themeV3.mobiCol10 .middleCenter').css(
            'background-color',
            '#ffffff'
        );

        // 3.0下拉框新样式
        selectValueChange('#fillAcctInfo');
    }
};

const checkHasMobileOption = (optionList) => {
    var hasMobile = false;
    let _aid = window._aid;
    let logAidList = [
        1591627, 24784076, 16835847, 15546092, 14346383, 24418638, 24434187,
        20343605, 23140239, 13940875,
    ];
    if (optionList) {
        if (logAidList.includes(_aid)) {
            loginLog({
                type: _aid + '-wxWinListener-js-3',
                data: 'checkHasMobileOption' + jm.toJSON(optionList),
            });
        }
        for (var i = 0; i < optionList.length; i++) {
            if (
                optionList[i]['fieldKey'] == 'mobile' &&
                optionList[i]['otherLoginMust']
            ) {
                hasMobile = true;
                break;
            }
        }
    }
    if (logAidList.includes(_aid)) {
        loginLog({
            type: _aid + '-wxWinListener-js-4',
            data: 'checkHasMobileOption' + jm.toJSON(optionList),
        });
    }
    return hasMobile;
};

const bindOtherAcctFirstSubmit = function (
    loginType,
    uid,
    faiOpenIdGreen,
    faiOpenId
) {
    var info = {},
        acct = jm('#bindUser').val(),
        pwd = jm('#bindPassword').val();

    let dataOption = {};

    if (acct == null || acct == '') {
        mobiIng(LS.memberSignupRegisterAcctEmpty);
        document.getElementById('bindUser').focus();
        return;
    }
    if (pwd == null || pwd == '') {
        mobiIng(LS.memberSignupRegisterPwdEmpty);
        document.getElementById('bindPassword').focus();
        return;
    }
    pwd = jm.md5(pwd);
    info['acct'] = acct;
    info['pwd'] = pwd;

    if (faiOpenId == 'true') {
        Object.assign(dataOption, {
            loginType: 5,
            uid,
            faiOpenId,
        });
        if (
            typeof Mobi.w_unionId != 'undefined' &&
            Mobi.w_unionId &&
            Mobi.w_unionId != ''
        ) {
            dataOption['unionId'] = Mobi.w_unionId;
        }
    } else {
        dataOption['loginType'] = 4;
        dataOption['uid'] = uid;
        if (typeof faiOpenId != 'undefined' && faiOpenId) {
            dataOption['faiOpenId'] = faiOpenId;
        }
        if (
            typeof Mobi.w_unionId != 'undefined' &&
            Mobi.w_unionId &&
            Mobi.w_unionId != ''
        ) {
            dataOption['unionId'] = Mobi.w_unionId;
        }
    }

    dataOption['info'] = jm.toJSON(info);

    bindOtherAcctFirstAjax(dataOption)
        .catch(() => {
            mobiIng(LS.memberSignupRegisterError);
        })
        .then((data) => {
            if (data.success) {
                if (data.fromBind) {
                    memberActive(data.mail, data.memName);
                } else {
                    if (data.active) {
                        memberActive(info.email, info.acct);
                    } else {
                        document.location.reload();
                    }
                }
            } else {
                if (data.rt == -401) {
                    mobiIng(LS.memberSignupRegisterCaptchaNotMatch);
                } else if (data.rt == -601) {
                    mobiIng(LS.reGetMobileCode);
                } else if (data.rt == -8) {
                    mobiIng(LS.mobileHasSigned);
                } else if (data.rt == -6) {
                    mobiIng(LS.memberSignupRegisterExisted);
                } else if (data.rt == -4) {
                    mobiIng(LS.memberSignupRegisterLimit);
                } else if (data.rt == -3) {
                    if (data.msg == '密码不正确') {
                        mobiIng(LS.memberPwdError);
                    } else {
                        mobiIng(LS.memberDialogNotFound);
                    }
                } else if (data.rt == otherLoginErrno.acctAlreadyBind) {
                    mobiIng(LS.memberOtherLgnAcctAlreadyBind);
                } else {
                    mobiIng(LS.memberSignupRegisterError);
                }
            }
        });
};

// 登录需要处理下 returnUrl 和 noReturn 字段
export const loadReturnUrlForLogin = (href) => {
    let returnUrl = localStorage.getItem('returnUrl');
    returnUrl = decodeHtml(returnUrl);
    localStorage.removeItem('returnUrl');
    var hasParam = false;
    if (href.indexOf('?') != -1) {
        hasParam = true;
    }
    // if (hasParam) {
    //     href = href.replace(/\+/g, '%2B');
    // }
    if (returnUrl) {
        if (hasParam) {
            href = href + '&returnUrl=' + returnUrl;
        } else {
            href = href + '?returnUrl=' + returnUrl;
        }
    } else {
        if (hasParam) {
            href = href + '&noReturn=true';
        } else {
            href = href + '?noReturn=true';
        }
    }
    return href;
};

// 获取注册手机短信验证码 -- 第三方登录必填项的手机验证码
const getSignMobileCodeForFill = /*#__PURE__*/ function (showCaptcha) {
    if (VITE_APP_MODE !== 'visitor') {
        mobiIng(
            '您目前处于网站管理状态，请先点击网站右上方的“退出”后再获取短信验证码。'
        );
        return;
    }

    var mobile = jm('#mobile').val(),
        mobileCt = jm('#mobileCt').val(),
        memberSignupCaptcha = jm('#memberSignupCaptcha').val(),
        mCode = '';

    if (!jm.isNationMobile(mobile)) {
        mobiIng(LS.mobileNumRegular);
        return;
    }

    if (memberSignupCaptcha == null || memberSignupCaptcha == '') {
        mobiIng(LS.memberSignupRegisterCaptchaEmpty);
        return;
    }

    if (showCaptcha) {
        Fai._needFaitest = true;
    }

    var isEncryptType = false;
    if (Fai.top._encryptType) {
        if (
            typeof mobile != 'undefined' &&
            Fai.top._faiEncryptKey &&
            Fai.top._encryptType > 0
        ) {
            // eslint-disable-next-line no-undef
            var encrypt = new JSEncrypt();
            encrypt.setPublicKey(Fai.top._faiEncryptKey);
            if (memberSignupCaptcha) {
                memberSignupCaptcha = encrypt.encrypt(memberSignupCaptcha);
                isEncryptType = true;
            }
            if (Fai.top._encryptType == 1) {
                // eslint-disable-next-line no-undef
                encrypt = new JSEncrypt1();
            } else if (Fai.top._encryptType == 2) {
                // eslint-disable-next-line no-undef
                encrypt = new JSEncrypt2();
            } else if (Fai.top._encryptType == 3) {
                // eslint-disable-next-line no-undef
                encrypt = new JSEncrypt3();
            }
            encrypt.setPublicKey(Fai.top._faiEncryptKey);
            mCode = encrypt.encrypt(mobile);
        }
    }

    //	info = {};
    //	info.mobile = mobile;
    //	info.mobileCt = mobileCt;
    //	info.captcha = memberSignupCaptcha;
    var bssKey = 'AObmzq0GCAEQARoDWzldIgnllJDkuJbmsJE'; //获取手机验证码滑动验证的场景bsskey
    var getCodeAction = function (checkSign) {
        let options = {
            mobile,
            mobileCt,
            mCode,
            validateCode: memberSignupCaptcha,
            isEncryptType,
        };

        if (checkSign) {
            options.bssKey = bssKey;
            options.checkSign = checkSign;
        }

        getMobileCode(options)
            .catch(() => {
                mobiIng(LS.getMobileCodeErrAf);
            })
            .then((data) => {
                if (data.success) {
                    mobiIng(LS.sendMobileCodeSuc);
                    getSignMobileCodeCountDown();
                    Mobi._needFaitest = false;
                    Fai.top.tmpMobileCodeSgin = data.mobileCodeSign;
                } else {
                    if (data.needCode) {
                        Mobi._needFaitest = true;
                        Mobi.getSignMobileCode();
                        jm('.J_memberSignupCaptcha').removeClass(
                            'memberSignupCaptchaHide'
                        );
                    }
                    Mobi.changeValidateCode(jm('#signupCaptchaImg'));
                    jm('#memberSignupCaptcha').val('');
                    if (data.rt == -401) {
                        if (!data.needCode) {
                            mobiIng(LS.memberSignupRegisterCaptchaNotMatch);
                        }
                    } else if (data.rt == -2) {
                        mobiIng(LS.js_argsError);
                    } else if (data.rt == 2) {
                        mobiIng(LS.memberDialogSendMobileCodeErr);
                    } else if (data.rt == -4 || data.rt == 8) {
                        mobiIng(LS.getMobileOneMin);
                    } else if (data.rt == -8) {
                        mobiIng(LS.getMobileHalfHour);
                    } else if (data.rt == 3) {
                        mobiIng(LS.memberDialogMobileMoneyErr);
                    } else if (data.rt == 9) {
                        mobiIng(LS.memberDialogSendMobileCodeLimit);
                    } else if (data.rt == 101) {
                        mobiIng(LS.mobileSetErr);
                    } else if (data.rt == -6) {
                        mobiIng(LS.mobileHasSigned);
                    } else if (data.rt == 23) {
                        mobiIng(LS.mobileNationTplErr);
                    } else if (data.rt == -301) {
                        mobiIng(LS.smsRanout);
                    } else if (data.rt == -1002) {
                        // Mobi.showPluralPopup("mobile", data.headImg, data.name, data.acct, info);
                    } else {
                        mobiIng(LS.getMobileRefresh);
                    }
                }
            });
    };

    if (Mobi._needFaitest) {
        // eslint-disable-next-line no-undef
        initFaitest(
            {
                bss: 1,
                bssKey,
            },
            function (checkSign) {
                getCodeAction(checkSign);
            }
        );
    } else {
        getCodeAction();
    }
};

const isVisitor = function () {
    let urlParam = new URLSearchParams(location.search);
    let isPreview = urlParam.get('_preview');
    return !(VITE_APP_MODE !== 'visitor') && isPreview != 'true';
};
